const mediaItems = [
  {
    title: '每日大赛官方网站入口教程视频',
    desc: '手把手教你如何通过每日大赛官网入口快速访问平台，包含注册、登录和基础操作演示',
    duration: '05:28',
    image: 'https://readdy.ai/api/search-image?query=A%20modern%20tutorial%20video%20thumbnail%20style%20with%20a%20laptop%20screen%20showing%20colorful%20interface%2C%20play%20button%20overlay%2C%20warm%20studio%20lighting%2C%20professional%20tech%20content%20creator%20setup%2C%20clean%20and%20inviting%20aesthetic&width=800&height=450&seq=media-01&orientation=landscape',
  },
  {
    title: '每日大赛APP安装全流程演示',
    desc: '覆盖iOS和Android两大平台的每日大赛APP下载安装流程，解决安装过程中常见报错问题',
    duration: '08:15',
    image: 'https://readdy.ai/api/search-image?query=A%20smartphone%20app%20installation%20tutorial%20scene%2C%20two%20phones%20showing%20download%20progress%2C%20warm%20desk%20setup%2C%20clean%20workspace%2C%20modern%20tech%20education%20style%2C%20soft%20natural%20lighting&width=800&height=450&seq=media-02&orientation=landscape',
  },
  {
    title: '每日大赛新功能亮点速览',
    desc: '快速浏览每日大赛平台近期上线的全新功能模块，了解最新界面和交互设计变化',
    duration: '03:42',
    image: 'https://readdy.ai/api/search-image?query=A%20dynamic%20product%20feature%20showcase%20with%20floating%20UI%20elements%2C%20modern%20tech%20presentation%20style%2C%20warm%20gradient%20background%2C%20professional%20software%20demo%20aesthetic%2C%20clean%20and%20engaging%20visual&width=800&height=450&seq=media-03&orientation=landscape',
  },
];

export default function Media() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
            影音中心
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            每日大赛教程演示与功能速览，通过视频快速了解平台使用方法
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 max-w-5xl mx-auto">
          {mediaItems.map((item, idx) => (
            <div
              key={idx}
              className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300"
            >
              <div className="aspect-video relative overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-background-50/90 text-primary-600 shadow-lg group-hover:scale-110 transition-transform duration-300">
                    <i className="ri-play-fill text-xl"></i>
                  </div>
                </div>
                <div className="absolute bottom-3 right-3 px-2 py-0.5 bg-background-900/70 text-background-50 text-xs rounded">
                  {item.duration}
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading font-semibold text-sm text-foreground-900 mb-1 leading-snug">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}